import Vue from "vue";
import VueTour from "vue-tour";

import "vue-tour/dist/vue-tour.css";

Vue.use(VueTour);
